<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
        <b-row>
          <b-col md="12">
          <b-form-group
            label="Ruangan"
            label-for="Ruangan"
          >
                <v-select
                id="ruangan_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="ruanganOption.options"
                v-model="userData.ruangan_id"
                placeholder="Pilih Ruangan"
              />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Tanggal"
            label-for="tanggal"
          >
          <b-form-datepicker v-model="userData.tanggal" locale="id"></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="Waktu"
            label-for="Waktu"
          >
                <v-select
                id="waktu_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="val => val.value"
                :options="waktuOption.options"
                v-model="userData.waktu_ujian_id"
                placeholder="Pilih Waktu"
              />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group
            label="Keterangan"
            label-for="keterangan"
          >
            <b-form-input
              v-model="userData.keterangan"
              name="keterangan"
              placeholder="keterangan"
            />
          </b-form-group>
        </b-col>
      </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>

      </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
import moment from 'moment'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import {
  getWaktuUjian,
  getRuangan,
} from '@/connection-api/master'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      userData,
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      waktuOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu --' },
        ],
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    getWaktuUjian()
      .then(response => {
          this.buildOption(response.data, this.waktuOption)
      })
    .catch(error => {});
    getRuangan()
      .then(response => {
          this.buildOption(response.data, this.ruanganOption)
      })
    .catch(error => {});
  },
  methods: {
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    async updateData() {
      store.dispatch('jadwal-external-umum/updateData', this.rowData.data)
        .then(response => {
          this.makeToast('success', 'Simpan Data Jadwal External Umum Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({name: 'jadwal-external-umum'})
          }, 3000);
        })
        .catch(error => {
        })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: 'Jadwal External Umum',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
}
</script>

<style>

</style>
